// extracted by mini-css-extract-plugin
module.exports = {"modalDescription":"_1lUpY","smallModal":"_1P5yW","button":"wfxhD"};